import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSnackbar } from "notistack";
import { useNavigate, useParams } from "react-router-dom";
import endpoint from "../config";
import { Grid, Box } from "@mui/material";
import { Link } from "react-router-dom";
import VideoCard from "./VideoCard";
import VideoPlayer from "./VideoPlayer";
import logo from "../assets/xflix-logo.png"
import "./VideoPage.css"

const VideoPage=()=>{
  const { enqueueSnackbar } = useSnackbar();
  const [video, setVideo] = useState({});
  const params = useParams();
  const navigate=useNavigate();
  const [allVideoList, setAllVideoList] = useState([]);
  useEffect(() => {
    getVideoData(params.id);
    getAllVideos();
        // eslint-disable-next-line
    }, [params.id]);
  const handleError = (e) => {
    if (e.response) {
      enqueueSnackbar(e.response.data.message, { variant: "error" });
    } else {
      enqueueSnackbar(
        "Something went wrong. Check that the backend is running, reachable and returns valid JSON.",
        { variant: "error" }
      );
    }
  };
  const getAllVideos = async () => {
    let response;
    try {
      response = await axios.get(endpoint);
      setAllVideoList(response.data.videos);
    } catch (e) {
      handleError(e);
    }
  };
    
  const getVideoData = async (id) => {
    try {
      const response = await axios.get(`${endpoint}/${id}`);
      console.log(response.data);
      setVideo(response.data);
    } catch (e) {
      handleError(e);
      navigate.push("/");
     }
  };
      
  // const handleVoteChange=async(id, vote, change)=>{
  //   let reqObj={
  //     vote,
  //     change
  //   };
  //   try{
  //     await axios.patch(`${endpoint}/${id}/votes`, reqObj)
  //     getVideoData(params.id);
  //   } catch (e) {
  //     handleError(e)
  //   }
  // }

  return(
    <>
    <Box className="header-box" sx={{ height: "10vh", bgcolor: "#202020" }}>
      <Box
        display="flex"
        justifyContent="start"
        alignItems="center"
        sx={{ paddingX: "1rem" }}
      >
        <Box className="header-title" marginTop="1rem">
          <Link to="/">
            <img src={logo} alt="XFlix-icon" />
          </Link>
        </Box>
      </Box>
    </Box>
    <Grid container paddingY="1rem" paddingX="2rem" spacing={3}>
      {video ? (
      <Grid item xs={12}>
        <VideoPlayer 
        //   handleVoteChange={handleVoteChange}
          video={video}
          getVideoData={getVideoData}
        />
      </Grid>
      ) : (
        <div style={{ color: "#fff" }}>Loading...</div>
       )}
       {allVideoList.map((video) => (
          <Grid item xs={12} sm={6} md={3} key={video._id}>
            <Link
              to={`/video/${video._id}`}
              className="video-tile-link"
              style={{ textDecoration: "none", color: "white" }}
            >
              <VideoCard video={video} />
            </Link>
          </Grid>
        ))}
      </Grid>
    </>
  )
}
 export default VideoPage;